import HeroSliderLeft from "pages/liveTvPage/home/HeroSliderLeft";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import { Navigation, Autoplay, Pagination } from "swiper";
import { useEffect, useState } from "react";
import Sliders from "services/sliders/Sliders";
import WelcomeHeroSlider from "components/skeleton/WelcomeHeroSlider";

function HeroSlider({ welcome }: any) {
  const [slider, setSlider] = useState<any[]>([]);
  const [isLoading, setIsLoding] = useState<any>(false);

  useEffect(() => {
    setIsLoding(true);
    const getSliderData = async () => {
      await Sliders.welcomePageSlider().then((res) => {
        setIsLoding(false);
        setSlider(res.data);
      });
    };

    getSliderData();
  }, []);

  useEffect(() => {
    setTimeout(() => {
      setIsLoding(false);
    }, 3000);
  }, [isLoading]);

  return (
    <>
      {!isLoading && slider && slider?.length > 0 && (
        <div className="hero-slider relative mt-4 mb-10">
          {/* OTT-style thin-line pagination */}
          <style>{`
            .hero-slider .swiper-pagination-bullet {
              width: 22px;
              height: 4px;
              border-radius: 9999px;
              background: rgba(255,255,255,0.4);
              opacity: 1;
              transition: all 0.3s ease;
            }
            .hero-slider .swiper-pagination-bullet-active {
              width: 34px;
              background: #F50537;
            }
          `}</style>
          {/* Static welcome overlay — stays fixed while slides change */}
          {welcome && (
            <div className="pointer-events-none absolute inset-x-0 top-0 z-30 rounded-t-2xl bg-gradient-to-b from-black/85 via-black/35 to-transparent px-10 pt-7 pb-24 max-sm:px-5 max-sm:pt-5">
              {welcome}
            </div>
          )}

          <Swiper
            navigation={false}
            modules={[Navigation, Autoplay, Pagination]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: true,
            }}
            pagination={{
              clickable: true,
            }}
            className="mySwiper"
          >
            {slider?.map((d: any, i) => (
              <SwiperSlide key={i}>
                <HeroSliderLeft data={d} />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      )}
      {isLoading && slider?.length > 0 && <WelcomeHeroSlider />}
    </>
  );
}

export default HeroSlider;